<div id="frequency-datasheet" style="width: 100%; height: 400px"></div>
<div style="display: none; position: absolute; top: 0; left: 0">
  <div *ngFor="let week of weekGraphData; let i = index">
    <div
      id="chart-container-frequency-{{ behaviorId }}-{{ i }}"
      style="width: 750px; height: 400px"></div>
  </div>
</div>
